import React from "react";
import Navbar  from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
const TermCondition = () => {
    return (
        
        <div >

<Navbar />
<div  style={{padding:60}}>
            <p>
                <h1>TERMS AND CONDITIONS</h1>
                <br />
                Last Updated: 10th February 2023

                <br />
                <br />
                INTRODUCTION
                <br />
                <br />
                These Terms and Conditions (“Terms”) govern the use of the services provided by FreshPage
                Technology Private Limited (“Company”, “us”, “we”, or “our”). Fresh Page Platform and
                Mobile Application (“Platform”) is operated by us and by accessing and/or otherwise using the
                Services in any manner (whether as a registered user or otherwise), you, therefore, agree that you
                have read and accepted these Terms. We reserve the right to modify these Terms, without notice,
                at any time. You understand that your continued use of the Services after these Terms have been
                modified constitutes your acceptance of these Terms as amended.
                <br />
                <br />
                Regularly checking and reviewing this page ensures that you are updated on the terms and
                conditions governing your use of the Services and your Account. If we believe that the
                modifications are material, we will notify you of the changes by posting a notice on our
                Platform, or emailing you at the email address provided to us by you, and as we may deem
                appropriate. What constitutes a material change will be determined by us, at our sole and
                absolute discretion.
                <br />
                <br />
                These Terms are to be read together with and do incorporate our Privacy Policy. If you do not
                agree with these Terms and/or our Privacy Policy, please do not use the Services. In this Policy
                "you", "your" and/or “Users” refers to the user of the Platform.
                <br />
                <br />
                ACCEPTANCE OF THIS AGREEMENT<br />
                <br />
                Your use of the Platform and services are governed by the following Terms as applicable to the
                Platform including the applicable policies which are mentioned on the Platform. If You transact
                on the Platform, You shall be subject to the policies that are applicable to the Platform for such
                transaction. By mere use of the Platform, You shall be contracting with the Company and these
                terms and conditions including the policies constitute Your binding obligations, with the
                Company.
                <br />
                <br />
                ACCESSING, BROWSING OR OTHERWISE USING THE SITE INDICATES YOUR
                AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF
                USE, SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING.
                <br />
                <br />
                ACCEPTANCE OF OTHER TERMS AND POLICY
                <br />
                <br />
                By using the Service, you agree to comply with the following policies and any additional policies
                that we may notify you of from time to time (“Policies”). These Terms apply to all Users:
                <br />
                <br />
                ● Privacy Policy
                <br />
                <br />
                ● Cookies Policy
                <br />
                <br />
                ● Disclaimer
                <br />
                <br />
                REGISTRATION, ACCOUNTS, AND PASSWORDS
                <br />
                <br />
                A User is required to create an account by using an email and password and providing the
                necessary details about the User in order to be eligible to use any of our E-books, magazines,
                novels, music and other electronic items or any other service on the Platform (the “Product” or
                "Services").
                <br />
                <br />
                User(s) are responsible for the personal protection and security of any password or email you
                may use to access the Platform. You are responsible for all activity conducted on the Platform
                that can be linked or traced back to your email or password.
                <br />
                <br />
                You are obligated to immediately report a lost or stolen password or email to our Customer
                Service. If you believe someone has used your password or account without your authorization,
                you must notify Customer Service immediately.
                <br /><br />

                We reserve the right to access and disclose any information, including user names of accounts,
                and other information to comply with applicable laws and lawful government requests.
                <br /><br />

                EMAIL COMMUNICATION
                <br /><br />

                By using our Platform, subscribing to our services, or otherwise creating an account on the
                Platform, you understand that we may send you communications or data regarding our Products
                and Services. You agree to receive all notifications regarding offers, rewards, coupons, E-books,
                magazines, novels, music and other electronic items from us.
                <br /><br />

                Please keep us informed of any changes in your email address so you may continue to receive
                our communications without interruption.
                <br /><br />

                Please refer to our Electronic Communication Policy
                <br /><br />

                SUBSCRIPTION POLICY
                <br /><br />

                Users who Subscribe to our Subscription program are referred to as "Subscribers". You can use
                a debit card and other payment methods to make payments.
                <br /><br />

                SUBSCRIPTION PLAN
                PLAN DURATION PRICE BENEFITS
                <br /><br />

                Cancellation: Subscribers may cancel their subscription before it expires, which means they
                exhaust their current subscription plan. In this situation, they won't receive any compensation.
                The account will turn back into a free account when the subscription expires. Within that 30-day
                notice period, customers have the option to cancel their subscriptions.
                <br /><br />

                I want to upgrade my plan: If you want to upgrade to a more expensive plan, you will be charged
                for the difference in price for the remaining months. We don't refund any payments if you
                downgrade to a cheaper plan.<br /><br />

                AUTO-RENEWAL SUBSCRIPTION
                <br /><br />

                After your initial subscription period, and again after any subsequent subscription period, your
                subscription will automatically continue for an additional equivalent period (each a "Renewal
                Term"), at the renewal price communicated to you at the time you purchased your initial
                subscription ("Renewal Price"), unless the Company provides you with at least thirty (30) days
                advance notice of a change in your Renewal Price.<br /><br />

                You agree that your account will be subject to this automatic renewal feature. If you want to
                change or terminate your subscription, you can anytime change or terminate the subscription.<br />
                If you cancel your subscription, you may use your subscription until the end of your then-current
                subscription term; your subscription will not be renewed after your then-current term expires,
                and you won't be eligible for any refund of any portion of the subscription fee paid for the
                then-current subscription period.<br /><br />

                By subscribing, you authorize the Company to charge your provided payment method now and
                again at the beginning of any Renewal Term. You also authorize the Company to charge you for
                any sales or similar taxes that may be imposed on your subscription payments. Upon the renewal
                of your subscription, if the Company does not receive payment from your payment method or
                payment method provider, (i) you agree to pay all amounts due on your account upon demand,
                and/or (ii) you agree that the Company may either terminate or suspend your subscription and
                continue to attempt to charge your payment method until payment is received.<br />
                USE OF THE PLATFORM AND THE SERVICES<br /><br />

                You may use the Platform and the Services only for lawful purposes and in accordance with
                these Terms of Conditions.<br /><br />

                You hereby agree not to use the Platform and the Services:<br /><br />
                1. In any way that violates any applicable national or international law or regulation.<br /><br />
                2. For the purpose of exploiting, harming, or attempting to exploit any person or harm
                minors in any way by exposing them to inappropriate content or otherwise.<br /><br />
                3. To transmit, or procure the sending of, any advertising or promotional material, including
                any “junk mail”, “chain letter,” “spam,” or any other similar solicitation.<br /><br />
                4. In any way that infringes upon the rights of others, or in any way is illegal, threatening,
                fraudulent, or harmful, or in connection with any unlawful, illegal, fraudulent, or harmful
                purpose or activity.<br /><br />
                Additionally, you agree not to:<br /><br />
                1. Introduce any viruses, trojan horses, worms, logic bombs, or other material which is<br />
                malicious or technologically harmful.<br /><br />
                2. Attempt to gain unauthorized access to, interfere with, damage, or disrupt any parts of<br />
                Service, the server on which the Platform is stored, or any server, computer, or database<br />
                connected to Service.<br /><br />
                3. Take any action that may damage or falsify Platform’s reputation.<br /><br />
                4. In any way decompile, reverse engineer, or disassemble any material or content on the<br />
                Platform.<br /><br />
                5. Otherwise, attempt to interfere with the proper working of the Platform and the Service.<br /><br />
                USERS' WARRANTIES, RIGHTS, REPRESENTATIONS, RESTRICTIONS,
                AND OBLIGATIONS.<br /><br />
                Subject to these Terms, Users will be granted a limited, non-exclusive, revocable,
                non-transferable, and non-sublicensable right to access Platform.<br /><br />
                By agreeing to grant such access, the Platform does not obligate itself to maintain the Platform in
                its present form. The Platform may upgrade, modify, change, or enhance the Services thereof at
                any time in its sole discretion, to the extent that this is not detrimental to User’s use of the
                Services and on reasonable prior notice to User (unless the change is of critical business
                importance or outside the Platform’s control, in which case the Platform will explain the reason
                for the changes as soon as is reasonably practicable).<br /><br />
                User agrees to abide by any rules or regulations that the Platform publishes with respect to the
                conduct of Users which rules and regulations are hereby incorporated into these Terms by this
                reference.<br /><br />
                The Platform reserves the right to deny a User access to Our Service if, in the Platform’s sole
                discretion, User has failed to abide by these Terms or appears likely to do so.<br /><br />
                User will not delete or alter any copyright, trademark or other proprietary rights notices from
                copies of materials from the Platform or contained in the Services;<br /><br />
                It will not use the Services in any manner, or in connection with any content, data, hardware,
                software or other materials that infringe upon or violates any patent, copyright, trade secret,
                trademark, or other intellectual property rights of any third party.<br /><br />
                ACCURACY, COMPLETENESS, AND TIMELINESS OF INFORMATION<br /><br />
                We are not responsible if the information made available on this Platform is not accurate,
                complete, or current. The material on this Platform is provided for general information and for
                education only and should not be relied upon or used as the sole basis for making decisions
                without consulting primary, more accurate, more complete, or more timely sources of
                information. Any reliance on the material on this Platform is at your own risk.<br /><br />
                We reserve the right to modify the contents of this Platform at any time, but we have no
                obligation to update any information on our Platform. You agree that it is your responsibility to
                monitor changes to our Platform.<br /><br />
                CONTENT<br /><br />
                All information about the Products on our Platform is provided for information/ and educational<br /><br />
                purposes only. The Platform accepts no liability for unintentional inaccuracies or misstatements<br /><br />
                about Products and Services. This does not affect your statutory rights.<br /><br />
                MODIFICATIONS TO THE SERVICE AND PRICES<br /><br />
                Prices for our Products and Services are subject to change without notice. We reserve the right at<br /><br />
                any time to modify or discontinue the Product or Service (or any part or content thereof) without<br /><br />
                notice at any time.<br /><br />
                We shall not be liable to you or to any third party for any modification, price change, suspension,<br /><br />
                or discontinuance of the Product or Services.<br /><br />
                PRIVACY AND USAGE OF COOKIES<br /><br />
                The Platform will not intentionally disclose any personally identifying information about you to<br /><br />
                third parties, except where the Platform, in good faith, believes such disclosure is necessary to<br /><br />
                comply with the law or enforce these Terms. By using the Platform, you signify your acceptance<br /><br />
                of the Platform’s Privacy.<br /><br />
                Users signing up for the Platform are opting in to receive newsletters and other special offers<br /><br />
                through emails/notifications from the Platform. If you do not wish to receive these emails, you<br /><br />
                may opt out anytime.<br /><br />
                Please refer to our Privacy Policy and Cookies Policy.<br /><br />
                LINKS TO OTHER WEB SITES<br /><br />
                Our Platform may contain links to third-party Platforms or services that are not owned or<br /><br />
                controlled by the Platform. For Example, Our Social Media (Youtube, Instagram, Facebook etc. )<br /><br />
                The Platform has no control over and assumes no responsibility for the content, privacy policies,<br /><br />
                or practices of any third-party Platforms or services. We do not warrant the offerings of any of<br /><br />
                these entities/individuals or their Platforms.<br /><br />
                INTELLECTUAL PROPERTY RIGHTS<br /><br />
                "Intellectual Property Rights" means any and all rights existing from time to time under patent<br /><br />
                law, copyright law, moral rights law, trade secret law, trade mark law, unfair competition law,<br /><br />
                publicity rights law, privacy rights law, all other proprietary rights, as well as, any and all<br /><br />
                applications, renewals, extensions, restorations and reinstatements thereof, now or hereafter in<br /><br />
                force and effect worldwide.<br /><br />
                All material and content on the Platform, including images, illustrations, text, graphics, logos,<br /><br />
                button icons, images, audio clips, digital downloads, data compilations and software, is our<br /><br />
                property, or the property of our affiliates or content suppliers, and is protected by the domestic as<br /><br />
                well as international intellectual property law, including copyright, authors’ rights, database<br /><br />
                rights laws, trademarks, and other intellectual property rights that are owned and controlled by us<br /><br />
                or by other parties that have licensed their material to us.<br /><br />
                The compilation of all content on the Platform is our exclusive property and is protected by<br /><br />
                domestic as well as international copyright and database rights laws.<br /><br />
                You hereby agree to not copy, reproduce, republish, upload, post, transmit or distribute such<br /><br />
                material in any way, including by e-mail or other electronic means whether directly or indirectly<br /><br />
                and you must not assist any other person to do so. Without the prior written consent of the owner,<br /><br />
                modification of the materials, use of the materials on any other Platform or use of the materials<br /><br />
                for any purpose other than personal, non-commercial use is a violation of the copyrights,<br /><br />
                trademarks and other proprietary rights, and is prohibited.<br /><br />
                Please refer to our Copyright Policy.<br /><br />
                INDEMNIFICATION<br /><br />
                You understand and agree that you are personally responsible for your behaviour on the<br /><br />
                Platform. You agree to indemnify, defend and hold Platform harmless from and against all<br /><br />
                claims, losses, expenses, damages and costs (including, but not limited to, direct, incidental,<br /><br />
                consequential, exemplary and indirect damages), and reasonable attorneys' fees, resulting from or<br /><br />
                arising out of your use, misuse, or inability to use the Platform or Services or the Content, or any<br /><br />
                violation by you of these Terms.<br /><br />
                SEVERABILITY<br /><br />
                The provision or part-provision of this Agreement is or becomes invalid, illegal or<br /><br />
                unenforceable, it shall be deemed modified to the minimum extent necessary to make it valid,<br /><br />
                legal and enforceable. If such modification is not possible, the relevant provision or<br /><br />
                part-provision shall be deemed deleted. Any modification to or deletion of a provision or<br /><br />
                part-provision under this clause shall not affect the validity and enforceability of the rest of this,<br /><br />
                agreement. If any provision or part-provision of this Agreement is invalid, illegal or<br /><br />
                unenforceable, the parties shall negotiate in good faith to amend such provision so that as<br /><br />
                amended, It is legal, valid and enforceable, and, to the greatest extent possible, achieves the<br /><br />
                intended commercial result of the original provision."<br /><br />
                ENTIRE AGREEMENT<br /><br />
                The failure of us to exercise or enforce any right or provision of these Terms and Conditions<br /><br />
                shall not constitute a waiver of such right or provision.<br /><br />
                These Terms and Conditions and any policies or operating rules posted by us on this site or in<br /><br />
                respect to the Service constitute the entire agreement and understanding between you and us and<br /><br />
                govern your use of the Service, superseding any prior or contemporaneous agreements,<br /><br />
                communications and proposals, whether oral or written, between you and us.<br /><br />
                Any ambiguities in the interpretation of these Terms and Conditions shall not be construed<br /><br />
                against the drafting party.<br /><br />
                GOVERNING LAW AND JURISDICTION<br /><br />

                These Terms and any separate agreements whereby we provide you Services shall be governed<br /><br />
                by and construed in all respects in accordance with the Laws of India and shall have exclusive<br /><br />
                jurisdiction over any dispute arising under this Agreement.<br /><br />
                TERMINATION<br /><br />
                We may terminate or suspend your account and bar access to the Platform or any of the Services<br /><br />
                immediately, without prior notice or liability, under our sole discretion, for any reason<br /><br />
                whatsoever and without limitation, including but not limited to a breach of these Terms of<br /><br />
                Conditions or any other Agreement.<br /><br />
                If you wish to terminate/delete your account, you may simply go to Account Section and<br /><br />
                terminate/delete your account.<br /><br />
                All provisions of these Terms of Conditions which by their nature should survive termination<br /><br />
                shall survive termination, including, without limitation, ownership provisions, warranty<br /><br />
                disclaimers, indemnity and limitations of liability. Notwithstanding the foregoing, if you breach<br /><br />
                these Terms of Conditions or Privacy Policy or other rules and policies, the Platform reserves the<br /><br />
                right to recover any amounts due and owing by you or to take strict legal action including but not<br /><br />
                limited to a referral to the appropriate police or other authorities for initiating criminal or other<br /><br />
                proceedings against you.<br /><br />
                NOTICES<br /><br />
                Legal notices must be served on the email address provided in the ‘Contact Us’ clause. Notice<br /><br />
                will be deemed given 48 hours after the email is sent unless the sending party is notified that the<br /><br />
                email address is invalid or that the email has not been delivered. Alternatively, we may give you<br /><br />
                legal notice by mail to the address provided by you during the registration process. In such case,<br /><br />
                notice will be deemed given three days after the date of mailing.<br /><br />
                LEGAL DISPUTES<br /><br />
                If a dispute arises between you and Platform, our goal is to provide you with a neutral and<br /><br />
                cost-effective means of resolving the dispute quickly. We strongly encourage you to first contact<br /><br />
                us to seek a resolution. If your dispute is not resolved by contacting Customer Service, all legal<br /><br />
                notices and formal disputes should be sent to Platform’s email id in accordance with the<br /><br />
                above-mentioned Clause. We agree to consider resolving the dispute through alternative dispute<br /><br />
                resolution procedures, such as mediation or arbitration, as alternatives to litigation in accordance<br /><br />
                with the Laws of India.<br /><br />
                The Place for alternative dispute resolution is in Ahmedabad, Gujarat, India.<br /><br />
                FORCE MAJEURE<br /><br />
                The Company is not liable for any delay in the performance or non-performance of any of its<br /><br />
                obligations hereunder and shall not be liable for any loss or damages caused thereby where the<br /><br />
                same is occasioned by any cause whatsoever that is beyond our control including but not limited<br /><br />
                to an Act of God, war, civil disturbance, governmental restrictions, prohibitions or enactments of<br /><br />
                any kind, any endemic, pandemic, epidemic or outbreak of any disease including Covid-19.<br /><br />
                REMOVAL OF DOUBTS<br /><br />
                Notwithstanding anything stated in this agreement, for any unforeseen issues arising, and not<br /><br />
                covered by this agreement, or in the event of differences of interpretation, the CEO of the<br /><br />
                Platform may take a decision as he/she may deem fit. The decision of the CEO shall be final.<br /><br />
                WAIVER<br /><br />
                If you breach these Terms and we take no action, we will still be entitled to use our rights and<br /><br />
                remedies in any other situation where you breach these Terms.<br /><br />
                AMENDMENTS<br /><br />
                Notwithstanding anything contained hereinbefore, The Platform may amend and implement the<br /><br />
                Terms, whenever required, in the interest of maintaining the standard and improving user<br /><br />
                experience without any prior notice and you shall be governed by such Terms so implemented<br /><br />
                from time to time.<br /><br />
                Please review the Terms from time to time on a regular basis since your ongoing use is subject to<br /><br />
                the Terms as amended.<br /><br />
                ACKNOWLEDGEMENT<br /><br />
                By using the Platform or other services provided by us, you acknowledge that you have read<br /><br />
                these Terms and agree to be bound by them.<br /><br />
                CONTACT US<br /><br />
                If you have any questions or concerns pertaining to the Terms, then please contact us at the<br /><br />
                contact details mentioned below.<br />
                Grievance Officer: Mr Rakesh Savaliya<br />
                Email: Help@freshPage.in<br />
                Phone Number: +919825311888<br />
            </p>
            </div>
            <Footer />
        </div>
    );
};

export default TermCondition;